import { render, staticRenderFns } from "./bFaqView.vue?vue&type=template&id=d5c22a56&scoped=true"
import script from "./bFaqView.vue?vue&type=script&lang=js"
export * from "./bFaqView.vue?vue&type=script&lang=js"
import style0 from "./bFaqView.vue?vue&type=style&index=0&id=d5c22a56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5c22a56",
  null
  
)

export default component.exports